import { array, boolean, nullable, number, optional, string, type, record, unknown } from 'superstruct';
export const OptionsWithValues = type({
    name: string(),
    value: string()
});
export const ItemAddedToCart = type({
    id: number(),
    properties: nullable(optional(record(string(), unknown()))),
    quantity: number(),
    variant_id: number(),
    key: string(),
    title: nullable(string()),
    price: number(),
    original_price: number(),
    discounted_price: number(),
    line_price: number(),
    original_line_price: number(),
    total_discount: number(),
    discounts: array(unknown()),
    sku: nullable(optional(string())),
    grams: number(),
    vendor: nullable(optional(string())),
    taxable: nullable(boolean()),
    product_id: nullable(optional(number())),
    product_has_only_default_variant: nullable(optional(boolean())),
    gift_card: boolean(),
    final_price: number(),
    final_line_price: number(),
    url: string(),
    featured_image: nullable(type({
        alt: nullable(string()),
        height: nullable(number()),
        url: nullable(string()),
        width: nullable(number())
    })),
    handle: nullable(optional(string())),
    requires_shipping: nullable(boolean()),
    product_type: nullable(optional(string())),
    product_title: nullable(optional(string())),
    product_description: nullable(optional(string())),
    variant_title: nullable(string()),
    variant_options: nullable(array(string())),
    options_with_values: nullable(array(OptionsWithValues)),
    line_level_discount_allocations: array(unknown()),
    line_level_total_discount: number()
});
export const ItemsAddedToCart = type({
    items: array(ItemAddedToCart)
});
